import {datadogRum, RumInitConfiguration} from '@datadog/browser-rum';

import BenchlingConfig from 'BenchlingConfig';

const _excludedActivityUrls = [
  /\/api\/analytics\/track$/,
  /\/api\/metrics$/,
  /\/api\/sesion:keep-alive$/,
  /\/api\/analytics:track-event$/,
];

function getInit(applicationId: string, clientToken: string): RumInitConfiguration {
  return {
    applicationId,
    clientToken,
    site: 'datadoghq.com',
    useSecureSessionCookie: true,
    service: 'benchling-web',
    env: window.DEPLOY_ENVIRONMENT,
    version: window.REVISION,
    allowedTracingUrls: [window.location.origin],
    defaultPrivacyLevel: 'mask',
    sessionSampleRate: 100,
    sessionReplaySampleRate: BenchlingConfig.PERF_ENABLE_SESSION_REPLAY ? 100 : 0,
    // automatically start recording replays on init if config is enabled
    startSessionReplayRecordingManually: !BenchlingConfig.PERF_ENABLE_SESSION_REPLAY,
    trackUserInteractions: true,
    trackViewsManually: true,
    trackResources: true,
    trackLongTasks: true,
    excludedActivityUrls: _excludedActivityUrls,
    traceSampleRate: BenchlingConfig.PERF_APM_SAMPLING_RATE_WEB,
  };
}

export function configureDatadogRum(applicationId: string, clientToken: string): void {
  datadogRum.init(getInit(applicationId, clientToken));
  datadogRum.setGlobalContext({
    deploy: window.DEPLOY_NAME,
    tenant: window.TENANT_SUBDOMAIN,
    viewportWidth: document.documentElement.clientWidth,
    viewportHeight: document.documentElement.clientHeight,
  });
}
